<template>
  <div class="d-flex mb-3 mt-2">
    <!-- <b-dropdown
    size="sm"
    right
    variant="default"
    toggle-class="text-decoration-none"
    no-caret
    ref="dropdown"
  >
    <template slot="button-content"
      ><i class="fa fa-cogs"></i
    ></template> -->
    <!-- <b-dropdown-form class="pl-3 pr-3"> -->
    <b-form-checkbox
      @change="toggleConfirmation()"
      v-model="notify_on_new_booking"
      switch
      class="mr-4"
    >
      Send e-post ved nye bookinger
      <i
        v-b-tooltip.hover
        title="Motta en e-postbekreftelse hver gang en deltaker booker seg på en ledig dato."
        class="fa fa-info-circle hoverable"
      ></i>
    </b-form-checkbox>
    <b-form-checkbox
      @change="toggleConfirmation()"
      v-model="notify_on_booking_closed"
      switch
    >
      Send e-post når booking stenger
      <i
        v-b-tooltip.hover
        title="Motta en e-post ved bookingfrist som oppsummerer antall påmeldte deltakere, samt link til å laste ned deltakerlister."
        class="fa fa-info-circle hoverable"
      ></i>
    </b-form-checkbox>
    <!-- </b-dropdown-form>
  </b-dropdown> -->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { suppliers } from "@/api";

export default {
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  mounted() {
    this.notify_on_new_booking = this.user.supplier.notify_on_new_booking;
    this.notify_on_booking_closed = this.user.supplier.notify_on_booking_closed;
  },
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_URL,
      notify_on_new_booking: false,
      notify_on_booking_closed: false,
    };
  },
  methods: {
    ...mapActions({
      getAvailableDates: "bookings/getAvailableDates",
      getUser: "auth/getUser",
    }),
    async toggleConfirmation() {
      await suppliers.updateNotifications({
        notify_on_new_booking: this.notify_on_new_booking,
        notify_on_booking_closed: this.notify_on_booking_closed,
      });

      this.user.supplier.notify_on_new_booking = this.notify_on_new_booking;
      this.user.supplier.notify_on_booking_closed = this.notify_on_booking_closed;

      this.$store.commit('auth/SET_USER', this.user);

      this.$bvToast.toast(`Endringerne er lagret`, {
        variant: "success",
        title: "Innstillinger oppdatert",
        autoHideDelay: 5000,
      });
    },
    submitForm() {
      let origParticipants = this.event.participants;
      const url = `${this.rootUrl}/bookings/dates/${this.event.id}/participants`;
      axios.put(url, { participants: this.participants }).then((res) => {
        this.$refs.dropdown.hide(true);
        this.getAvailableDates();
        this.$bvToast.toast(
          `Antallet plasser er nå endret fra ${origParticipants} til ${this.participants}`,
          {
            variant: "success",
            title: "Antallet plasser er nå endret",
            autoHideDelay: 5000,
          }
        );
      });
    },
  },
};
</script>
